import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import CssBaseline from "@material-ui/core/CssBaseline"
import { ThemeProvider, makeStyles } from "@material-ui/core/styles"

import theme from "../theme"
import Header from "./header"
import Footer from "./footer"
import EditionFooter from "./editionFooter"

// Style

const useStyles = makeStyles({
  main: {
    paddingBottom: "1.45rem",
    "& h2, & h3": {
      paddingBottom: "1rem",
    },
  }
})

interface Props {
  location?: string
  children?: JSX.Element | JSX.Element[]
}

const Layout = ({ location, children }: Props) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          doi
          menuLinks {
            name
            link
          }
        }
      }
    }
  `)

  const classes = useStyles()

  const footer = location === "mdl" ? <EditionFooter/> : <Footer/>

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header
        location={location || ''}
        siteTitle={data.site.siteMetadata.title}
        menuLinks={data.site.siteMetadata.menuLinks}
        doi={data.site.siteMetadata.doi}
      />
      <div className={classes.main}>
        {children}
      </div>
      {footer}
    </ThemeProvider>
  )
}

export default Layout
